import { FC } from "react"
import { Contact } from "../../../module/systems/containers/contact"

export const ContactPage: FC = () => <Contact />
